const ReviewVideo = () => {
  const videos = [...document.querySelectorAll('.customers-reviews__card-video video')];
  const videoWrappers = [...document.querySelectorAll('.customers-reviews__card-video')];

  if (videoWrappers.length > 0) {
    videoWrappers.forEach(videoWrapper => {
      const video = videoWrapper.querySelector('video');

      videoWrapper.addEventListener('click', () => {
        videos.forEach(v => {
          if (v !== video) {
            v.pause();
            v.closest('.customers-reviews__card-video').classList.remove('playing');
          }
        });

        if (video.paused) {
          videoWrapper.classList.add('playing');
          video.play();
        } else {
          videoWrapper.classList.remove('playing');
          video.pause();
        }
      });
    });
  }
}

export default ReviewVideo;